import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'react-final-form';
import {Link, SaveButton, Panel, FileUploader} from '../../common';

export default class CompleteProfile extends Component {
  static propTypes = {
    updateUser: PropTypes.func.isRequired,
    user: PropTypes.shape({
      id: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      image: PropTypes.string,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    const {user: {image}} = props;
    this.state = {image};
  }

  onFormSubmit = () => {
    const {image = null} = this.state;
    const {updateUser, user} = this.props;
    const redirectUrl = '/lobby';

    updateUser({...user, image, redirectUrl});
  };

  onFileUploaded = (image) => {
    this.setState({image});
  };

  renderLink = () => (
    <Link to="/lobby" theme="secondary" size="xs" type="button" text="Skip" icon="angle-right" className="button_rounded"/>
  );

  renderForm = ({handleSubmit, submitting}) => {
    const {user: {firstName, lastName}} = this.props;
    const {image} = this.state;
    const isDisabled = submitting || !image;

    return (
      <form className="form form_m complete-profile" onSubmit={handleSubmit}>
        <div className="row row_center">
          <FileUploader
            modificator="avatar"
            hint={`${firstName} ${lastName}`}
            selectedMedia={image}
            onFileUploaded={this.onFileUploaded}
          />
        </div>
        <div className="row row_center">
          <SaveButton size="xl" type="submit" text="Save" disabled={isDisabled}/>
        </div>
      </form>
    );
  };

  render() {
    return (
      <Panel
        title="Choose your profile picture"
        size="m"
        renderActions={this.renderLink()}
      >
        <Form
          onSubmit={this.onFormSubmit}
          validateOnBlur={false}
          render={({handleSubmit, submitting}) => this.renderForm({handleSubmit, submitting})}
        />
      </Panel>
    );
  }
}
